import { all, fork } from 'redux-saga/effects'

import * as activity from './Activity/activity.sagas'
import * as battles from './Battles/battles.sagas'
import * as components from './Components/components.sagas'
import * as dataConsume from './DataConsumeWarning/dataConsume.sagas'
import * as documents from './Documents/documents.sagas'
import * as endTurn from './EndTurn/endTurn.sagas'
import * as events from './Events/events.sagas'
import * as indicators from './Indicators/indicators.sagas'
import * as pointsManager from './PointsManager/pointsManager.sagas'
import * as loader from './Phases/LoaderScreen/loader.sagas'
import * as map from './Map/map.sagas'
import * as mining from './Mining/mining.sagas'
import * as phase0 from './Phases/Phase0Screen/phase0.sagas'
import * as phases from './Phases/phases.sagas'
import * as profile from './Profile/profile.sagas'
import * as quizzes from './Quizzes/quizzes.sagas'
import * as ranking from './Ranking/ranking.sagas'
import * as resumes from './Resumes/resumes.sagas'
import * as savePoint from './SavePoint/savePoint.sagas'
import * as settings from './Settings/settings.sagas'
import * as survey from './Survey/survey.sagas'
import * as ui from './UI/ui.sagas'
import * as toast from './Toast/toast.sagas'
import * as endgame from './Phases/EndGameScreen/endgame.sagas'

/**
 *  Mars sagas
 */
export function* sagas() {
  yield all([
    // Here comes the sagas of each module
    fork(activity.sagas),
    fork(battles.sagas),
    fork(components.sagas),
    fork(dataConsume.sagas),
    fork(documents.sagas),
    fork(events.sagas),
    fork(pointsManager.sagas),
    fork(endTurn.sagas),
    fork(indicators.sagas),
    fork(loader.sagas),
    fork(map.sagas),
    fork(mining.sagas),
    fork(phase0.sagas),
    fork(phases.sagas),
    fork(profile.sagas),
    fork(quizzes.sagas),
    fork(ranking.sagas),
    fork(resumes.sagas),
    fork(savePoint.sagas),
    fork(settings.sagas),
    fork(survey.sagas),
    fork(toast.sagas),
    fork(ui.sagas),
    fork(endgame.sagas),
  ])
}
